<script lang="ts">
  import '../app.css';
  import QueryProvider from '@/components/QueryProvider.svelte';
  import AuthProvider from '@/components/AuthProvider.svelte';
  import { MaintenanceScreen } from '@/components/maintenance';
  import { MAINTENANCE_MODE } from '@/lib/maintenance';

  let { children } = $props();
</script>

<!--
  Maintenance gate. When MAINTENANCE_MODE is true the entire app is replaced
  by a single notice — no trading UI mounts, by button or by URL. Flip the
  flag in `src/lib/maintenance.ts` to false + redeploy to go back online.
-->
{#if MAINTENANCE_MODE}
  <MaintenanceScreen />
{:else}
  <QueryProvider>
    <AuthProvider>
      {@render children()}
    </AuthProvider>
  </QueryProvider>
{/if}
